export enum EnumFiltroBloqueioCliente {
    Todos = -1,
    NaoBloqueado = 0,
    Bloqueado = 1,
}
